<script>
export default {
  data() {
    return {
      title: "Settings",
      text: "Customer",
      text1: "Settings",
      isPasswordVisible: false,
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/provider-settings/connected-apps");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <div class="card user-sidebar mb-4 mb-lg-0">
              <div class="card-header user-sidebar-header mb-4">
                <div class="d-flex justify-content-center align-items-center flex-column">
                  <span class="user rounded-circle avatar avatar-xxl mb-2">
                    <img
                      src="@/assets/img/profiles/avatar-21.jpg"
                      class="img-fluid rounded-circle"
                      alt="Img"
                    />
                  </span>
                  <h6 class="mb-2">John Smith</h6>
                  <p class="fs-14">Member Since Sep 2021</p>
                </div>
              </div>
              <div class="card-body user-sidebar-body pt-0">
                <ul>
                  <li class="mb-4">
                    <router-link to="/customer/user-dashboard" class="d-flex align-items-center">
                      <i class="ti ti-layout-grid me-2"></i>
                      Dashboard
                    </router-link>
                  </li>
                  <li class="mb-4">
                    <router-link to="/customer/user-booking-list" class="d-flex align-items-center">
                      <i class="ti ti-device-mobile me-2"></i>
                      Bookings
                    </router-link>
                  </li>
                  <li class="mb-4">
                    <router-link to="/customer/favourites" class="d-flex align-items-center">
                      <i class="ti ti-heart me-2"></i>
                      Favorites
                    </router-link>
                  </li>
                  <li class="mb-4">
                    <router-link to="/customer/customer-wallet" class="d-flex align-items-center">
                      <i class="ti ti-wallet me-2"></i>
                      Wallet
                    </router-link>
                  </li>
                  <li class="mb-4">
                    <router-link to="/customer/customer-reviews" class="d-flex align-items-center">
                      <i class="ti ti-star me-2"></i>
                      Reviews
                    </router-link>
                  </li>
                  <li class="mb-4">
                    <router-link to="/customer/user-chat" class="d-flex align-items-center">
                      <i class="ti ti-message-circle me-2"></i>
                      Chat
                    </router-link>
                  </li>
                  <li class="submenu mb-4">
                    <a href="javascript:void(0);" class="d-block mb-3"
                      ><i class="ti ti-settings me-2"></i><span>Settings</span
                      ><span class="menu-arrow"></span
                    ></a>
                    <ul class="ms-4">
                      <li class="mb-3">
                        <router-link
                          to="/customer-settings/account-settings"
                          class="fs-14 d-inline-flex align-items-center"
                          ><i class="ti ti-chevrons-right me-2"></i>Account Settings</router-link
                        >
                      </li>
                      <li class="mb-3">
                        <router-link
                          to="/customer-settings/security-settings"
                          class="fs-14 d-inline-flex align-items-center active"
                          ><i class="ti ti-chevrons-right me-2"></i>Security Settings</router-link
                        >
                      </li>
                      <li class="mb-3">
                        <router-link
                          to="/customer-settings/notification-settings"
                          class="fs-14 d-inline-flex align-items-center"
                          ><i class="ti ti-chevrons-right me-2"></i>Notifications</router-link
                        >
                      </li>
                      <li class="mb-3">
                        <router-link
                          to="/customer-settings/connected-apps"
                          class="fs-14 d-inline-flex align-items-center"
                          ><i class="ti ti-chevrons-right me-2"></i>Connected Apps</router-link
                        >
                      </li>
                      <li class="mb-3">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-account"
                          class="fs-14"
                          ><i class="ti ti-chevrons-right me-2"></i>Delete Account</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="mb-0">
                    <router-link to="/" class="d-flex align-items-center">
                      <i class="ti ti-logout me-2"></i>
                      Logout
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h4>Login Activity</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-resposnive">
                  <table class="table datatable">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Device Name</th>
                        <th>IP Address</th>
                        <th>Location</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p class="text-gray fs-14">22 Sep 2022, 11:40:30</p>
                        </td>
                        <td><p class="fs-14">Chrome - Windows</p></td>

                        <td><p class="text-gray fs-14">232.222.12.72</p></td>
                        <td><p class="fs-14 text-gray">Chennai / India</p></td>
                        <td>
                          <span class="badge badge-success-100 p-2">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="text-gray fs-14">21 Sep 2022, 13:10:50</p>
                        </td>
                        <td><p class="fs-14">Safari Macos</p></td>

                        <td><p class="text-gray fs-14">224.111.12.75</p></td>
                        <td><p class="fs-14 text-gray">Newyork / USA</p></td>
                        <td>
                          <span class="badge badge-success-100 p-2">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="text-gray fs-14">20 Sep 2022, 14:16:10</p>
                        </td>
                        <td><p class="fs-14">Firefox Windows</p></td>

                        <td><p class="text-gray fs-14">111.222.13.28</p></td>
                        <td><p class="fs-14 text-gray">Chennai / India</p></td>
                        <td>
                          <span class="badge badge-success-100 p-2">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p class="text-gray fs-14">19 Sep 2022, 10:20:20</p>
                        </td>
                        <td><p class="fs-14">Safari Macos</p></td>

                        <td><p class="text-gray fs-14">333.555.10.54</p></td>
                        <td><p class="fs-14 text-gray">Chennai / India</p></td>
                        <td>
                          <span class="badge badge-success-100 p-2">Completed</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
